import { supabase } from '../lib/supabase';

/**
 * Carga los tracking pixels desde system_settings y los inyecta en el DOM
 * Solo se ejecuta en páginas públicas (no admin ni client)
 */
export async function loadTrackingPixels() {
  try {
    // Solo cargar en páginas públicas, no en admin ni cliente
    const path = window.location.pathname;
    if (path.startsWith('/admin') || path.startsWith('/client')) {
      return;
    }

    // Leer fila completa para detectar dinámicamente la columna
    const { data, error } = await supabase
      .from('system_settings')
      .select('*')
      .eq('setting_key', 'tracking_pixels')
      .maybeSingle();

    if (error) {
      console.error('Error cargando tracking_pixels:', error);
      return;
    }

    if (!data) {
      return;
    }

    // Detectar dinámicamente qué columna contiene el JSON
    let pixels: any = {};
    if (data.setting_value) {
      pixels = data.setting_value;
    } else if (data.value) {
      pixels = data.value;
    } else if (data.data) {
      pixels = data.data;
    } else if (data.json) {
      pixels = data.json;
    } else {
      // No hay columna reconocida, usar objeto vacío
      return;
    }

    // Facebook Pixel
    if (pixels.facebookPixelId && pixels.facebookPixelId.trim() !== '') {
      !(function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);

      (window as any).fbq('init', pixels.facebookPixelId);
      (window as any).fbq('track', 'PageView');

      const noscript = document.createElement('noscript');
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.src = `https://www.facebook.com/tr?id=${pixels.facebookPixelId}&ev=PageView&noscript=1`;
      noscript.appendChild(img);
      document.body.appendChild(noscript);
    }

    // Google Analytics
    if (pixels.googleAnalyticsId && pixels.googleAnalyticsId.trim() !== '') {
      const gaScript = document.createElement('script');
      gaScript.async = true;
      gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${pixels.googleAnalyticsId}`;
      document.head.appendChild(gaScript);

      (window as any).dataLayer = (window as any).dataLayer || [];
      function gtag(...args: any[]) {
        (window as any).dataLayer.push(args);
      }
      gtag('js', new Date());
      gtag('config', pixels.googleAnalyticsId);
    }

    // Google Tag Manager
    if (pixels.googleTagManagerId && pixels.googleTagManagerId.trim() !== '') {
      (function (w: any, d: any, s: any, l: any, i: any) {
        w[l] = w[l] || [];
        w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
        const f = d.getElementsByTagName(s)[0];
        const j = d.createElement(s);
        const dl = l !== 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, 'script', 'dataLayer', pixels.googleTagManagerId);

      const noscript = document.createElement('noscript');
      const iframe = document.createElement('iframe');
      iframe.src = `https://www.googletagmanager.com/ns.html?id=${pixels.googleTagManagerId}`;
      iframe.height = 0;
      iframe.width = 0;
      iframe.style.display = 'none';
      iframe.style.visibility = 'hidden';
      noscript.appendChild(iframe);
      document.body.appendChild(noscript);
    }
  } catch (error) {
    // Silenciar errores en producción
    console.error('Error al cargar tracking pixels:', error);
  }
}
